import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  onCancelRsvp: () => Promise<void>;
};

export function ListingActionsDropdownCancelRsvp({ onCancelRsvp }: Props) {
  const { i18n } = useI18n();

  return (
    <Button
      type="button"
      qaId="cancel-rsvp-button"
      variant="tertiary-grey"
      onClick={() => {
        void onCancelRsvp();
      }}
      size="small"
    >
      {
        /* TRANSLATORS: event kebab menu item */
        i18n('Cancel registration')
      }
    </Button>
  );
}
